export default __webpack_public_path__ + "static/bg-build-branding-8b6100c944108a706be7570f607a2d05.png";